@use '@/styles/tokens' as *;

// The grid owns the page's only scrollbar: the title, tabs and search row above it stay fixed.
// `min-height: 0` is what allows it to shrink inside its flex parent instead of pushing the
// column taller than the viewport.
.scroller {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  // Each card's power disc overhangs its bottom edge by 5.5px, so leave room for the last row's
  // disc (and any focus ring) instead of clipping it against the scroll container.
  padding-block-end: var(--space-3);
}

// Figma node 232:355452 — three 378px columns, 32px apart, with a 22px row gap that absorbs the
// power disc's 5.5px overhang below each card.
//
// Three columns is a fixed count, not a floor: the page holds the design's 1304px content column
// at every width (`devices.page.module.scss`), so the cards keep their specified size instead of
// spreading on a wide display. The two `down()` tiers below are the only departures, and they
// exist so the card does not collapse on a narrow one.

.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: var(--space-8);
  row-gap: 22px;

  @include down(lg) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include down(md) {
    grid-template-columns: minmax(0, 1fr);
  }
}

// Empty and first-batch-error states share this centred well (Figma node 345:352908).
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  // Centre in whatever height the scroller actually has, rather than a guessed minimum.
  height: 100%;
  min-height: 320px;
}

.emptyIcon {
  color: var(--text-disabled);
}

.stateText {
  margin: 0;
  font-size: $font-size-md;
  line-height: 1.4;
  color: var(--text-muted);
}

// A failed *subsequent* batch keeps the grid and appends this row beneath it.
.batchError {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding-top: var(--space-6);
}

.loadingMore {
  margin: var(--space-6) 0 0;
  font-size: $font-size-sm;
  line-height: 1.4;
  color: var(--text-muted);
  text-align: center;
}

// Zero-height tripwire; the observer's rootMargin gives it a 200px lead.
.sentinel {
  height: 1px;
}
